// removed by extract-text-webpack-plugin
module.exports = {"block":"Location__block___21LVc","backIcon":"Location__backIcon___1FJ8i","locationIcon":"Location__locationIcon___rqgDN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Location/Location.css
// module id = 132
// module chunks = 0